/**
 * AuthGuard — redireciona para /login se o usuário não tem JWT na sessão.
 * Preserva a rota tentada via `state.from` para o LoginPage poder
 * devolver ao usuário onde ele queria chegar (UX padrão SPA). // ux-neutrality:allow doc-comment
 */
import { type ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSessionStore } from '@/stores/session';

export function AuthGuard({ children }: { children: ReactElement }): ReactElement {
  const token = useSessionStore((s) => s.token); // ux-neutrality:allow auth-token
  const location = useLocation();
  if (!token /* ux-neutrality:allow auth-token */) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
